import './Navigation.css'

import React, { useEffect, useState } from 'react'
import { MaterialSymbol } from 'react-material-symbols'

import { Button } from 'primereact/button'
import { classNames } from 'primereact/utils'

import { MicroAppNavigation, TenantNavigation } from './Menus'

export const Navigation: React.FC = () => {
  const navOpenClassName = 'open'
  const navClosedClassName = 'closed'
  const maskActiveClassName = 'active'

  const [sidebarClassName, setSidebarClassName] = useState(navClosedClassName)
  const [maskClassName, setMaskClassName] = useState('')
  const isNavMinimized = sidebarClassName === navClosedClassName
  const [isMobileView, setIsMobileView] = useState(false)

  function toggleClassNames(): void {
    const newClassNameSidebar =
      sidebarClassName === navClosedClassName
        ? navOpenClassName
        : navClosedClassName
    const newClassNameMask =
      maskClassName === maskActiveClassName ? '' : maskActiveClassName

    setSidebarClassName(newClassNameSidebar)
    setMaskClassName(newClassNameMask)
  }

  // If nav is open and you resize your window to
  // smartphone view the nav and black mask closes
  function handleResize(): void {
    if (window.innerWidth <= 992) {
      setSidebarClassName(navClosedClassName)
      setMaskClassName('')
      setIsMobileView(true)
    } else {
      setIsMobileView(false)
    }
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <>
      {/* Sidebar toggler */}
      <div
        className={classNames('button-sidebar-wrapper', {
          open: sidebarClassName === navOpenClassName,
        })}
      >
        <Button
          aria-label="Toggle menu"
          className={classNames('button-sidebar p-button-text p-button-plain', {
            active: sidebarClassName === navOpenClassName,
          })}
          onClick={toggleClassNames}
          icon={options =>
            !isNavMinimized && isMobileView ? (
              <MaterialSymbol icon="close" size={24} />
            ) : (
              <MaterialSymbol icon="menu" size={24} />
            )
          }
        />
      </div>

      {/* Navigation */}
      <nav className={'main-nav ' + sidebarClassName}>
        <MicroAppNavigation
          handleResize={handleResize}
          isNavMinimized={isNavMinimized}
        />
        <TenantNavigation
          handleResize={handleResize}
          isNavMinimized={isNavMinimized}
        />
      </nav>

      {/* Mask */}
      <div
        aria-hidden="true"
        role="button"
        className={'mask ' + maskClassName}
        onClick={toggleClassNames}
      ></div>
    </>
  )
}
